import React from "react";
import { Button, Card } from "@mantine/core";
import { Form } from "react-bootstrap";

export default function AddCard(props) {
  const { front, back, setFront, setBack, onSubmit } = props;
  return (
    <>
      <Card
        style={{
          maxWidth: "500px",
          width: "50%",
          height: "240px",
          borderRadius: "10px",
        }}
      >
        <Form>
          <Form.Group>
            <Form.Label>Front</Form.Label>
            <Form.Control
              name="front"
              value={front}
              onChange={(e) => setFront(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Back</Form.Label>
            <Form.Control
              name="back"
              value={back}
              onChange={(e) => setBack(e.target.value)}
            />
          </Form.Group>
          <Button
            className="w-100"
            size="lg"
            variant="light"
            style={{ marginTop: "10px"}}
            onClick={onSubmit}
          >
            Add Card
          </Button>
        </Form>
      </Card>
    </>
  );
}
